import { BASE_END_POINT } from "../../parametros";
import { MercadoPago_Produtos_ParametrizadosDTO } from "../dtos/MercadoPago_Produtos_ParametrizadosDTO";
import { RespostaSolicitacaoCompraDTO } from "../dtos/RespostaSolicitacaoCompraDTO";
import { SolicitaCompraProdutoDTO } from "../dtos/SolicitaCompraProdutoDTO";
import { alertService } from "./alertService";
import { obterSenhaSessao, obterUsuarioSessao } from "./salva-credenciais";
import i18n from '../../i18n/index';

async function solicitarCompraProduto(
    mercadoPagoSolicitacao: MercadoPago_Produtos_ParametrizadosDTO
): Promise<RespostaSolicitacaoCompraDTO> {

    try {
        const url = `${BASE_END_POINT}/api-v1/pagamentos/solicitacao`;

        const request: SolicitaCompraProdutoDTO = {
            IdProduto: mercadoPagoSolicitacao.Id,
            Usuario: obterUsuarioSessao()!,
            Senha: obterSenhaSessao()!
        };

        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept-Language': i18n.language
            },
            body: JSON.stringify(request),
        });

        if (!response.ok) {
            throw new Error(`Erro na solicitação: ${response.statusText}`);
        }

        const json: RespostaSolicitacaoCompraDTO = await response.json();
        return json;

    } catch (ex) {

        alertService.erro(
            i18n.t("PURCHASE_REQUEST_ERROR_TITLE"),
            i18n.t("PURCHASE_REQUEST_ERROR_MESSAGE")
        );

        console.error("Erro ao solicitar compra:", ex);
        throw ex;
    }
}

export { solicitarCompraProduto };
